import {
  fetchEntities,
  fetchJson,
  Method,
  toRequestOptions,
  crudApi,
  fetchEntity,
} from './api';
import {
  UseCaseSummary,
  PersistedUseCase,
  APIMetaModelPreview,
  ArdoqId,
  VisibilityUseCase,
} from '@ardoq/api-types';
import { ApiResponse } from './types';
import { isArdoqError } from '@ardoq/common-helpers';
import { Features, hasFeature } from '@ardoq/features';

const fetchMetamodelPreview = async (
  useCaseId: string
): ApiResponse<APIMetaModelPreview> => {
  const request = new Request(`/api/use-case/preview/${useCaseId}/metamodel`);
  return fetchJson(request);
};

const fetchMetaModel = async (
  useCaseId: string
): ApiResponse<APIMetaModelPreview> => {
  const request = new Request(`/api/use-case/view/${useCaseId}/metamodel`);
  return fetchJson(request);
};

const loadUseCase = async (useCaseId: string): ApiResponse<{ id: ArdoqId }> => {
  const request = new Request(
    `/api/use-case/preview/${useCaseId}/start`,
    toRequestOptions(Method.POST, {})
  );
  return fetchJson(request);
};

const fetchAvailable = async (): ApiResponse<UseCaseSummary[]> => {
  const result = await fetchEntities<UseCaseSummary>('use-case/available')();

  if (isArdoqError(result)) {
    return result;
  }

  return result.filter(useCase => isUseCaseAvailable(useCase));
};

export const isUseCaseAvailable = (useCase: any): boolean => {
  if (hasFeature(Features.DEV_SHOW_ALL_SOLUTIONS)) {
    return true;
  }

  if (hasFeature(Features.FOUNDATION_SOLUTION_ENABLE)) {
    if (
      useCase.name === VisibilityUseCase.ALM ||
      useCase.name === VisibilityUseCase.OM ||
      useCase.name === VisibilityUseCase.BCM ||
      useCase.name === VisibilityUseCase.BCR
    ) {
      return false;
    }
  } else if (useCase.name === VisibilityUseCase.F) {
    return false;
  }

  return true;
};

export const useCaseApi = {
  fetchAvailable,
  fetchMetaModel,
  fetchMetamodelPreview,
  loadUseCase,
  fetchUseCasePreviewContent: fetchEntity<PersistedUseCase>('use-case/preview'),
  fetchUseCaseContent: fetchEntity<PersistedUseCase>('use-case/view'),
  ...crudApi<PersistedUseCase>('use-case'),
};
